<div class="w-100 mt-2 rounded rounded-8 panel">
  <p-panel [toggleable]="true"
           [style]="{width: '100%', marginBottom: '20px'}"
           expandIcon="pi pi-chevron-up"
           collapseIcon="pi pi-chevron-down">
    <ng-template pTemplate="header">
      <div class="w-100 bg-white br p-4" style="box-sizing: border-box;">
        <div class="d-flex align-items-center justify-content-between mb-4" style="height: 40px;">
          <div class="d-flex flex-row align-items-center justify-content-between w-50" style="height: 90%;">
            <div class="d-flex align-items-center" style="height: 100%;">
              <div class="left-border"></div>
              <span class="title">🔥 Drift Intensity Matrix (Tables × Dates)</span>
            </div>
            <span class="p-input-icon-left" style="height: 100%;">
              <i class="pi pi-search hide"></i>
              <input type="text" placeholder="Search by name of ID" class="search-input w-100 hide" pInputText />
            </span>
          </div>
          <ng-container>
            <div class="row mb-2" style="padding-right:1.5rem;">
              
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <div class="w-65 bg-white br p-4" style="box-sizing: border-box;">
      <div class="d-flex flex-column scrollerbar">
        <div class="row w-100 mb-2 header-title">

          <div class="flex justify-between items-center mb-3">
            <div class="flex items-center gap-2">
              <p-checkbox [(ngModel)]="showLegend" [binary]="true"></p-checkbox>
              <label class="text-gray-700 dark:text-gray-200">Show Legend</label>
            </div>

            <div class="flex items-center gap-2">
              <p-checkbox [(ngModel)]="isDark" [binary]="true"></p-checkbox>
              <label class="text-gray-700 dark:text-gray-200">Dark Mode</label>
            </div>
          </div>

          <div class="chart-container">
            <ngx-charts-heat-map [view]="view"
                                 [scheme]="colorScheme"
                                 [results]="matrixData"
                                 [xAxis]="true"
                                 [yAxis]="true"
                                 [showXAxisLabel]="true"
                                 [showYAxisLabel]="true"
                                 [xAxisLabel]="'Date'"
                                 [yAxisLabel]="'Table'"
                                 [gradient]="true">
            </ngx-charts-heat-map>
          </div>
        </div>
      </div>
    </div>
  </p-panel>
</div>
